import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetPaymentCardsResponse } from './types';

export const getPaymentCards = async (): Promise<AxiosResponse<GetPaymentCardsResponse>> => {
    const response = await api.get('/commerce/checkout/paymentcardspagecontent');

    return response;
};
